import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faDownload,
  faFileCsv,
  faFileExcel,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const EXPORT_OPTIONS = [
  { format: "XLSX", icon: faFileExcel, key: "excel" },
  { format: "PDF", icon: faFilePdf, key: "pdf" },
  { format: "CSV", icon: faFileCsv, key: "csv" },
];

const GridReportExportMenu = ({
  onSelect,
  disabled = false,
  allowedFormats = ["XLSX", "PDF", "CSV"],
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (!containerRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", closeOnOutsideClick);
    return () => document.removeEventListener("mousedown", closeOnOutsideClick);
  }, []);

  const selectFormat = (format) => {
    setOpen(false);
    onSelect(format);
  };

  return (
    <div className="grid-report-export-menu" ref={containerRef}>
      <button
        type="button"
        className="btn btn-default grid-report-export-button"
        onClick={() => setOpen((current) => !current)}
        disabled={disabled}
        aria-haspopup="menu"
        aria-expanded={open}
        title={t("gridReports.export")}
      >
        <FontAwesomeIcon icon={faDownload} />
        <span>{t("gridReports.export")}</span>
        <FontAwesomeIcon icon={faCaretDown} className="grid-report-export-caret" />
      </button>
      {open && (
        <div className="grid-report-export-dropdown" role="menu">
          {EXPORT_OPTIONS.filter((option) => allowedFormats.includes(option.format)).map((option) => (
            <button
              type="button"
              role="menuitem"
              key={option.format}
              onClick={() => selectFormat(option.format)}
            >
              <FontAwesomeIcon icon={option.icon} />
              <span>{t(`gridReports.actions.${option.key}`)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default GridReportExportMenu;
